"use client";

import { useEffect } from "react";
import ChevronsRightIcon from "../../shared-components/icons/ChevronsRightIcon";
import { useUpsellSubscriptionContext } from "./upsell-subscription-context";
import Markdown from "react-markdown";
import { useTimer } from "../../hooks/useTimer";
import Skeleton from "react-loading-skeleton";

const PreSubscriptionModal = (props: any) => {
  const { preSubscriptionData, onNextStep, onFirstTimeMayBeLater, preSubscriptionDataLoading } =
    useUpsellSubscriptionContext();
  const { days, hours, minutes, seconds, milliseconds } = useTimer(
    "upsell-subscription-modal",
    (preSubscriptionData?.offer?.expireTime || 0) * 1000,
    undefined,
    "millisecond"
  );
  useEffect(() => {
    document.querySelector("body").classList.add("overflow-hidden");
    return () => {
      document.querySelector("body").classList.remove("overflow-hidden");
    };
  }, []);

  const { fromNavMenu = false, okClick } = props;
  const milisecondsT = Math.floor(milliseconds / 10)
    .toString()
    .padStart(2, "0");
  const shouldUseOfferTitle =
    preSubscriptionData?.offer?.offerTitle !== undefined &&
    preSubscriptionData?.offer?.offerTitle !== "" &&
    preSubscriptionData?.offer?.expireTime !== 0;
  const isCounterActive = typeof preSubscriptionData?.offer?.expireTime === "number";

  const isFromNavMenuClick = () => {
    if (fromNavMenu && okClick) {
      return (location.href = `${okClick}#main-plans-section`);
    }
    onNextStep();
    return;
  };

  return (
    <>
      <div data-name="Overlay" className="fixed inset-0 z-[1003] bg-black/80"></div>
      <div
        data-name="PopupContainer"
        className={"fixed inset-0 z-[1003] w-full min-h-full overflow-x-hidden overflow-y-auto"}>
        <div className={"w-full min-h-full flex-center flex-col m-auto"}>
          <div
            className={
              "bg-white relative w-full pb-4 lg:pb-5 lg:max-w-[1000px] lg:min-h-[614px] flex flex-col max-lg:grow lg:rounded-2xl"
            }>
            <button
              type="button"
              onClick={onFirstTimeMayBeLater}
              aria-label="Close"
              className="absolute top-4 lg:top-2 right-4 lg:right-2 z-10 size-6">
              <img
                src="/assets/images/upsell-subscription-modal/tabler-icon-x.svg"
                alt=""
                width={24}
                height={24}
                className="block size-6"
              />
            </button>
            {preSubscriptionDataLoading ? (
              <Skeleton
                count={1}
                inline
                highlightColor="#fff"
                containerClassName="flex flex-col w-full h-[100dvh] lg:h-[741px] lg:rounded-2xl"
                className="h-full"
              />
            ) : (
              <div className={"lg:flex lg:items-center lg:flex-col"}>
                {/*BANNER*/}
                <div className={"relative mb-[13px] lg:mb-2"}>
                  <div className={"lg:mb-4"}>
                    <video
                      autoPlay
                      muted
                      playsInline
                      webkit-playsinline
                      loop
                      src={preSubscriptionData.header.videoMobile}
                      className={"w-full h-auto lg:hidden"}
                      width={375}
                      height={246}></video>
                    <video
                      autoPlay
                      playsInline
                      webkit-playsinline
                      muted
                      loop
                      src={preSubscriptionData.header.video}
                      className={"w-full h-auto max-lg:hidden lg:rounded-t-2xl"}
                      width={1000}
                      height={280}></video>

                    {/*<video autoPlay muted loop src={"/assets/images/subscriptions/videos/upsell-video-m.mp4"} className={"w-full h-auto lg:hidden"} width={375} height={246}>*/}
                    {/*</video>*/}
                    {/*<video autoPlay muted loop src={"/assets/images/subscriptions/videos/upsell-video-d.mp4"} className={"w-full h-auto max-lg:hidden lg:rounded-t-2xl"} width={1000} height={280}>*/}
                    {/*</video>*/}
                  </div>
                  <div
                    className={"absolute left-1/2 top-11 lg:top-10 -translate-x-1/2 text-center font-jost w-full px-4"}>
                    <div
                      className={
                        "mb-1 text-white text-[22px] font-bold leading-7 lg:text-[28px] lg:font-semibold lg:leading-8 lg:mb-3"
                      }>
                      {preSubscriptionData.header.title}
                    </div>
                    <div className={"text-white text-base font-medium leading-5.5 lg:text-xl"}>
                      <Markdown
                        components={{
                          p: props => props.children,
                        }}>
                        {preSubscriptionData.header.subtitlep1}
                      </Markdown>{" "}
                      <strong className={"text-underline-special"}>
                        <Markdown
                          components={{
                            p: props => props.children,
                          }}>
                          {preSubscriptionData.header.subtitlep2}
                        </Markdown>
                      </strong>{" "}
                      <br className={"lg:hidden"} />
                      <Markdown
                        components={{
                          p: props => props.children,
                        }}>
                        {preSubscriptionData.header.subtitlep3}
                      </Markdown>
                    </div>
                  </div>
                </div>

                <div className={"max-lg:px-4 flex flex-col w-full lg:max-w-[856px]"}>
                  <div className={"mb-6 lg:flex lg:items-center lg:justify-center lg:mb-6 lg:gap-4"}>
                    {/*GREEN BULLETS*/}
                    <div className={"mb-6 lg:mb-0"}>
                      {preSubscriptionData.features.map(feature => (
                        <div key={feature} className={"flex items-center gap-1.5 mb-2.5 lg:mb-[18px] last:mb-0"}>
                          <div>
                            <svg
                              className={"size-4 lg:size-5"}
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none">
                              <path
                                d="M11.3359 2.22529C12.3414 2.80586 13.1779 3.63898 13.7625 4.64216C14.3471 5.64534 14.6595 6.78381 14.6689 7.94485C14.6783 9.1059 14.3843 10.2493 13.816 11.2618C13.2476 12.2743 12.4248 13.1208 11.4288 13.7175C10.4328 14.3142 9.29818 14.6405 8.13734 14.664C6.97649 14.6875 5.82964 14.4074 4.81031 13.8515C3.79098 13.2955 2.93452 12.483 2.32572 11.4943C1.71691 10.5056 1.37688 9.3751 1.33927 8.21463L1.33594 7.99863L1.33927 7.78263C1.37661 6.63129 1.71164 5.50927 2.3117 4.52595C2.91176 3.54264 3.75637 2.73159 4.7632 2.17188C5.77002 1.61217 6.9047 1.32289 8.05661 1.33225C9.20851 1.34161 10.3383 1.64929 11.3359 2.22529ZM10.4739 6.19396C10.3591 6.07917 10.2064 6.01022 10.0444 6.00003C9.88237 5.98985 9.72221 6.03913 9.59394 6.13863L9.53127 6.19396L7.33594 8.38863L6.47394 7.52729L6.41127 7.47196C6.28299 7.37253 6.12285 7.32331 5.96087 7.33353C5.7989 7.34375 5.64621 7.4127 5.53145 7.52747C5.41668 7.64223 5.34773 7.79492 5.33751 7.9569C5.32729 8.11887 5.37651 8.27902 5.47594 8.40729L5.53127 8.46996L6.8646 9.80329L6.92727 9.85863C7.04419 9.94934 7.18796 9.99857 7.33594 9.99857C7.48392 9.99857 7.62769 9.94934 7.7446 9.85863L7.80727 9.80329L10.4739 7.13663L10.5293 7.07396C10.6288 6.94569 10.6781 6.78552 10.6679 6.62351C10.6577 6.46149 10.5887 6.30875 10.4739 6.19396Z"
                                fill="#3DAE44"
                              />
                            </svg>
                          </div>
                          <div className={"text-[13px] text-[#4C4C52] font-jost font-normal leading-4.5 lg:text-base"}>
                            <Markdown
                              components={{
                                strong: props => <span className="font-semibold text-[#28282B]">{props.children}</span>,
                              }}>
                              {feature}
                            </Markdown>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/*CLAIM BOX*/}
                    {preSubscriptionData.offer ? (
                      <div
                        className={`relative lg:ml-auto ${isCounterActive || shouldUseOfferTitle ? "pt-5 lg:pt-0" : ""}`}>
                        {shouldUseOfferTitle && (
                          <div
                            className={
                              "absolute z-[1] top-0 lg:-top-5 flex px-4 lg:px-[13px] w-auto h-[60px] justify-center items-start gap-1 shrink-0 [background:var(--strong,linear-gradient(90deg,#431CA0_0%,#7230E7_100%))] pt-0.5 pb-[5px] rounded-2xl"
                            }>
                            <span
                              className={
                                "text-white font-jost text-xs font-normal leading-4 capitalize whitespace-nowrap"
                              }>
                              {preSubscriptionData.offer.offerTitle}
                            </span>
                          </div>
                        )}

                        {isCounterActive && (
                          <div
                            className={
                              "absolute z-[1] top-0 lg:-top-5 flex px-4 lg:px-[13px] w-auto h-[60px] justify-center items-start gap-1 shrink-0 [background:var(--strong,linear-gradient(90deg,#431CA0_0%,#7230E7_100%))] pt-0.5 pb-[5px] rounded-2xl"
                            }>
                            <span
                              className={
                                "text-white font-jost text-xs font-normal leading-4 capitalize whitespace-nowrap"
                              }>
                              Ends in <span className={"min-w-3.5 inline-flex text-right"}>{hours}</span>h :{" "}
                              <span className={"min-w-3.5 inline-flex justify-end"}>{minutes}</span>m :{" "}
                              <span className={"min-w-3.5 inline-flex text-right"}>{seconds}</span>
                              <span className={"min-w-3.5 inline-flex text-[9px]"}>{milisecondsT}</span>
                            </span>
                          </div>
                        )}
                        <div className={"relative z-[2] bg-red-to-orange rounded-2xl"}>
                          <div
                            className={
                              "text-center text-sm font-jost font-normal leading-4 lg:text-base lg:leading-4 text-white rounded px-[7px] py-1 lg:pt-2 lg:pb-1.5 whitespace-nowrap"
                            }>
                            <Markdown
                              components={{
                                strong: props => (
                                  <strong className="font-bold" {...props}>
                                    {props.children}
                                  </strong>
                                ),
                              }}>
                              {preSubscriptionData.offer.headline}
                            </Markdown>
                          </div>
                          <div
                            className={
                              "bg-white relative px-[7px] py-[5px] font-jost border border-[#FC8F0A] rounded-2xl lg:py-2 lg:px-4 lg:w-[400px]"
                            }>
                            <div className={"flex items-center gap-3"}>
                              <div>
                                <img
                                  src={preSubscriptionData.offer.offerImage}
                                  alt={"Claim"}
                                  width={64}
                                  height={64}
                                  className={"size-14 rounded-lg lg:size-16"}
                                />
                              </div>
                              <div>
                                <div
                                  className={
                                    "text-[13px] font-normal leading-5 text-secondary lg:text-gray-1 lg:text-sm lg:mb-1"
                                  }>
                                  {preSubscriptionData.offer.bonus}
                                </div>
                                <div className={"text-base font-bold leading-6.5 text-dark-1 lg:text-xl"}>
                                  {preSubscriptionData.offer.description}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>

                  {/*TOP SPECS INFO*/}
                  <div
                    className={
                      "max-lg:grid max-lg:grid-cols-4 gap-1.5 font-jost mb-4 lg:mb-6 lg:flex lg:items-center lg:gap-[50px]"
                    }>
                    {/*#1*/}
                    <div className={"flex flex-col items-center gap-1 lg:flex-row lg:gap-2"}>
                      <div className={"shrink-0"}>
                        <img
                          src={"/assets/images/subscriptions/top-specs-1.webp"}
                          alt={"cars-only"}
                          width={48}
                          height={48}
                          className={"size-8 lg:size-12"}
                        />
                      </div>
                      <div className={"max-lg:text-center"}>
                        <div className={"text-primary text-sm font-semibold leading-5 lg:text-xl"}>
                          {preSubscriptionData.header.yearsSincerLaunch}
                        </div>
                        <div
                          className={"text-secondary text-xs font-medium leading-3 lg:text-[13px] lg:leading-[15px]"}>
                          UK’s No. 1
                        </div>
                      </div>
                    </div>

                    {/*#2*/}
                    <div className={"flex flex-col items-center gap-1 lg:flex-row lg:gap-2"}>
                      <div className={"shrink-0"}>
                        <img
                          src={"/assets/images/subscriptions/top-specs-2.webp"}
                          alt={"cars-only"}
                          width={48}
                          height={48}
                          className={"size-8 lg:size-12"}
                        />
                      </div>
                      <div className={"max-lg:text-center"}>
                        <div className={"text-primary text-sm font-semibold leading-5 lg:text-xl"}>4.8 +</div>
                        <div
                          className={
                            "text-secondary text-[11px] font-medium leading-3 lg:text-[13px] lg:leading-[15px]"
                          }>
                          App Store
                          <br className={"lg:hidden"} /> Rating
                        </div>
                      </div>
                    </div>

                    {/*#3*/}
                    <div className={"flex flex-col items-center gap-1 lg:flex-row lg:gap-2"}>
                      <div className={"shrink-0"}>
                        <img
                          src={"/assets/images/subscriptions/top-specs-3.webp"}
                          alt={"cars-only"}
                          width={48}
                          height={48}
                          className={"size-8 lg:size-12"}
                        />
                      </div>
                      <div className={"max-lg:text-center"}>
                        <div className={"text-primary text-sm font-semibold leading-5 lg:text-xl"}>
                          {preSubscriptionData.header.totalPrizesGiven}
                        </div>
                        <div
                          className={
                            "text-secondary text-[11px] font-medium leading-3 lg:text-[13px] lg:leading-[15px]"
                          }>
                          In Prizes
                          <br className={"lg:hidden"} /> Given
                        </div>
                      </div>
                    </div>

                    {/*#4*/}
                    <div className={"flex flex-col items-center gap-1 lg:flex-row lg:gap-2"}>
                      <div className={"shrink-0"}>
                        <img
                          src={"/assets/images/subscriptions/top-specs-4.webp"}
                          alt={"cars-only"}
                          width={48}
                          height={48}
                          className={"size-8 lg:size-12"}
                        />
                      </div>
                      <div className={"max-lg:text-center"}>
                        <div className={"text-primary text-sm font-semibold leading-5 lg:text-xl"}>2.7M</div>
                        <div
                          className={
                            "text-secondary text-[11px] font-medium leading-3 whitespace-nowrap lg:text-[13px] lg:leading-[15px]"
                          }>
                          #1 Community of
                          <br className={"lg:hidden"} /> Prize Lovers
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      "text-center max-lg:fixed max-lg:min-h-[76px] max-lg:z-[100] max-lg:inset-x-0 max-lg:bottom-0 max-lg:bg-white max-lg:shadow-[0_1.5px_8px_0_rgba(0,0,0,0.20)] max-lg:px-[37px] max-lg:py-2"
                    }>
                    <div
                      className={
                        "mb-2 lg:mb-4 text-secondary font-jost text-[11px] font-medium leading-3 lg:text-[13px] lg:leading-[15px]"
                      }>
                      Cancel anytime
                    </div>
                    <button
                      onClick={isFromNavMenuClick}
                      className={`theme-btn theme-btn-primary theme-btn-md lg:theme-btn-lg uppercase max-lg:w-full min-w-[265px] btnWithArrow`}>
                      <span className="relative">
                        See all plans{" "}
                        <ChevronsRightIcon
                          variant={3}
                          className={
                            "size-5 shrink-0 absolute left-[calc(100%+theme(spacing.2))] inset-y-0 my-auto arrowImage"
                          }
                        />
                      </span>
                    </button>
                  </div>

                  <div
                    className={
                      "mt-4 lg:mt-6 text-[#696971] text-center font-jost text-[11px] font-normal leading-[14px] max-lg:mb-[76px] w-full max-w-[705px] mx-auto"
                    }>
                    <div className="flex flex-col gap-2.5 [&_p]:tracking-[0] [&_p]:m-0">
                      <Markdown
                        components={{
                          strong: props => <span className="font-medium text-[#4C4C52]">{props.children}</span>,
                        }}>
                        {preSubscriptionData.header.legalText}
                      </Markdown>
                      <p>
                        {preSubscriptionData.header.legalText && (
                          // <a href={"/"}></a>
                          <a
                            target="_blank"
                            href="https://www.botb.com/terms"
                            title={"Terms of Service"}
                            className={"!underline"}>
                            Terms and Conditions apply.
                          </a>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PreSubscriptionModal;
